import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

//
import "@/assets/css/style.css";
import VueAos from "vue-aos";
//
import AOS from "aos";
import "aos/dist/aos.css";
Vue.use(VueAos);
// const key = "AIzaSyBjCWbhzgr2zs5YgGZHaXlqRdXR12ltUTM";
// import * as VueGoogleMaps from "vue2-google-maps";
// Vue.use(VueGoogleMaps, { load: { key, libraries: "places" } });
//
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  mounted() {
    AOS.init({
      // Global settings:
      offset: 120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 400, // values from 0 to 3000, with step 50ms
      easing: "ease", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      anchorPlacement: "top-bottom", // def
    });
  },
}).$mount("#app");
